export const sortPlayers = (a: { isActive?: boolean }, b: { isActive?: boolean }) => {
    const aIsActive = a.isActive ? 1 : -1;
    const bIsActive = b.isActive ? 1 : -1;
    return bIsActive - aIsActive;
  };